import { ColDef } from 'ag-grid-community';
import { INTEGRATIONS } from '../../model/global-configuration.constant';

export class OnHoldReasonsGridColumnsModel {
	private entity: string;

	constructor(entity: string) {
		this.entity = entity;
	}

	/**
	 * Return columns configuration.
	 * @param appScopes
	 * @param acuities
	 */
	getColumns(): Array<ColDef> {
		return [
			{
				headerName: this.entity === INTEGRATIONS.NEXSYS ? 'Nexsys Reason' : 'FNC Reason',
				field: this.entity === INTEGRATIONS.NEXSYS ? 'nexsysReason' : 'fncReason',
				width: 120,
				resizable: true
			},
			{
				headerName: 'AppScope Comment Title',
				width: 120,
				autoHeight: false,
				cellRenderer: 'textBoxCellRenderer',
				cellRendererParams: {fieldId: 'appScopeTitle'}
			},
			{
				headerName: 'Acuity Reason',
				width: 120,
				cellRenderer: 'textBoxCellRenderer',
				cellRendererParams: {fieldId: 'acuityReason'}
			},
			{
				headerName: 'Cmp Acuity Reason',
				width: 120,
				cellRenderer: 'textBoxCellRenderer',
				cellRendererParams: {fieldId: 'cmpAcuityReason'}
			}
		];
	}
}
